<template>
  <div class="marketing-sms-list">
    <v-data-table class="marketing-sms-list-table"
                  :headers="headers"
                  :items="smsList"
                  :loading="loading"
                  :hide-actions="true"
                  :no-data-text="$t('message.generics.message.noResultsFound')"
                  :no-results-text="$t('message.generics.message.noResultsFound')"
                  disable-initial-sort>

      <template slot="items"
                slot-scope="props">
        <marketing-sms-list-item :item="props.item"
                                 :is-automation="filter.isAutomation"
                                 @resent="reloadListAndTotal"
                                 @duplicated="reloadList"
                                 @deleted="reloadList"
                                 @edited="reloadList" />
      </template>
    </v-data-table>

    <infinite-loading :identifier="infiniteId"
                      @infinite="fetchList">
      <div slot="no-results"></div>
      <div slot="no-more"></div>
    </infinite-loading>
  </div>
</template>

<script>
import MarketingSmsListItem from "@components/modules/marketing/sms/list/item/MarketingSmsListItem";
import EventBus from "@packages/event-bus";
import InfiniteLoading from "vue-infinite-loading";

export default {
  components: {
    MarketingSmsListItem,
    InfiniteLoading,
  },
  data() {
    return {
      loading: false,
      smsList: [],
      infiniteId: +new Date(),
      filter: {
        page: 0,
        filter: "",
        isAutomation: false,
      },
    };
  },
  props: {},

  computed: {
    headers() {
        return [
            { text: this.$t('message.generics.message.status'), value: "status", sortable: false },
            { text: this.$t('message.generics.message.name'), value: "title", sortable: false },
            { text: this.$t('message.marketingGenerics.message.numberSent'), value: "creationDate", sortable: true },
            { text: this.$t('message.marketingGenerics.message.sendDate'), value: "sentDate", sortable: true },
            { text: this.$t('message.marketingGenerics.message.actions'), value: "", sortable: false },
        ]
    }
  },
  created() {
    EventBus.$on("SMS_SET_SEARCH", this.searchList);
    EventBus.$on("SET_SMS_LIST_TAB", this.setIsAutomationAndReload);
    EventBus.$on("SMS_CREATED", this.reloadList);
  },
  beforeDestroy() {
    EventBus.$off("SMS_SET_SEARCH", this.searchList);
    EventBus.$off("SET_SMS_LIST_TAB", this.setIsAutomationAndReload);
    EventBus.$off("SMS_CREATED", this.reloadList);
  },
  methods: {
    setIsAutomationAndReload(value) {
      this.filter.isAutomation = value;

      this.reloadList();
    },
    reloadListAndTotal() {
      this.reloadList();
      EventBus.$emit("RELOAD_SMS_TOTAL");
    },
    async searchList(search) {
      this.filter.filter = search;
      this.reloadList();
    },
    async reloadList() {
      this.filter.page = 0;
      this.smsList = [];

      this.infiniteId++;
    },
    async fetchList($state) {
      this.loading = true;

      const smsList = await this.$api.marketing.sms.message.list({
        page: this.filter.page,
        filter: this.filter.filter,
        isAutomation: this.filter.isAutomation,
      });

      if (smsList.length) {
        this.filter.page += 1;

        this.smsList.push(...smsList);

        if ($state) {
          $state.loaded();
        }
      } else {
        if ($state) {
          $state.complete();
        }
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-sms-list {
  .marketing-sms-list-table {
    ::v-deep .v-table__overflow {
      padding-bottom: 100px;
    }
  }
}
</style>
